import { render, staticRenderFns } from "./anchorViewer.vue?vue&type=template&id=763dc2dd"
import script from "./anchorViewer.vue?vue&type=script&lang=js"
export * from "./anchorViewer.vue?vue&type=script&lang=js"
import style0 from "./anchorViewer.vue?vue&type=style&index=0&id=763dc2dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports